export default function calculateAPR(durationInDays, interestRate) {
  const apr = (interestRate * 365) / durationInDays;
  return apr.toFixed(2);
}
